import React from "react";
import { Zoom } from "react-reveal";
import { useNavigate } from "react-router-dom";

const EntertainmentSearch = ({ x, room_uuid, url }) => {
  const navigate = useNavigate();
const isMaintenance = String(url).toLowerCase().includes("maintenance");
  return (
    <div id={x.name} key={x.id}>
      <Zoom>
        <div
          className="con-img-container v3"
          onClick={() => {
            let target = "";

            if (url === "in-stay-shop/items") {
              target = x.category_id;
            } else if (url === "in-stay-rental/category") {
              target = x.category_id ? `${x.category_id}/items` : "";
            } else {
              target =
                x.uuid ||
                x.company_uuid ||
                x.salon_at_home_uuid ||
                x.housekeeping_uuid ||
                x.tour_desk_uuid ||
                x.laundry_uuid ||
                x.category_id;
            }

            if (!target) return;

            navigate(`/${room_uuid}/${url}/${target}`);
          }}
        >
          <div className={`con-img ${isMaintenance ? "maintenance-img" : ""}`}>
            <img src={x.image} alt="" />
            <p></p>
          </div>
        </div>
        <div className="con-text-container">
          <p>{x.name}</p>
          <hr className="mb-0 dark" />
        </div>
      </Zoom>
    </div>
  );
};

export default EntertainmentSearch;
